export enum Section {
  Sentiment,
  Comment,
  BookACall,
  Submitted,
}
